<template>
    <div class="w-fit">
        <h3 class=" px-4 py-3 bg-white inline-block uppercase text-gray-600 text-sm w-fit">
            {{ title }}
        </h3>
    </div>
</template>

<script>
export default {
    props: ['title']
};
</script>

